/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.DashboardGoals {
    angular.module('meevo.plugins.dashboardGoals', []);
}